    <template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
        <div class="animated fadeIn vld-parent custom-100">
            <b-row>
                <b-col>
                    <div style=" padding: 5px 10px 4px;border-bottom: 1px solid gray; ">
                        <b-row>
                            <div md="2" style="padding-right: 8px; padding-left: 15px">
                                <b-dropdown text="Filter">
                                    <b-dropdown-form>
                                        <b-form-checkbox class="mb-3" v-model="active_filters.commune">Kommune</b-form-checkbox>
                                    </b-dropdown-form>
                                    <b-dropdown-form>
                                        <b-form-checkbox class="mb-3" v-model="active_filters.tour">Tour</b-form-checkbox>
                                    </b-dropdown-form>
                                    <b-dropdown-form>
                                        <b-form-checkbox class="mb-3" v-model="active_filters.city">Ort</b-form-checkbox>
                                    </b-dropdown-form>
                                    <b-dropdown-form>
                                        <b-form-checkbox class="mb-3" v-model="active_filters.district">Ortsteil</b-form-checkbox>
                                    </b-dropdown-form>
                                    <b-dropdown-form>
                                        <b-form-checkbox class="mb-3" v-model="active_filters.area">Gebiet</b-form-checkbox>
                                    </b-dropdown-form>
                                    <b-dropdown-form>
                                        <b-form-checkbox class="mb-3" v-model="active_filters.object_location">Objektstandort</b-form-checkbox>
                                    </b-dropdown-form>
                                    <b-dropdown-form>
                                        <b-form-checkbox class="mb-3" v-model="active_filters.location">Stand</b-form-checkbox>
                                    </b-dropdown-form>
                                    <b-dropdown-form>
                                        <b-form-checkbox class="mb-3" v-model="active_filters.search">Baumnummer</b-form-checkbox>
                                    </b-dropdown-form>
                                </b-dropdown>
                            </div>
                            <b-col md="2" v-if="active_filters.commune === true">
                                <b-form-select class="black" plain
                                               :options="filters.commune"
                                               v-model="filter_selects.commune">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null">-- Kommune auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="2" v-if="active_filters.tour === true">
                                <b-form-select class="black" plain
                                               :options="filters.tour"
                                               v-model="filter_selects.tour">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null">-- Tour auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="2" v-if="active_filters.city === true">
                                <b-form-select class="black" plain
                                               :options="filters.city"
                                               v-model="filter_selects.city">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null">-- Ort auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="2" v-if="active_filters.district === true">
                                <b-form-select class="black" plain
                                               :options="filters.district"
                                               v-model="filter_selects.district">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null">-- Ortsteil auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="2" v-if="active_filters.area === true">
                                <b-form-select class="black" plain
                                               :options="filters.area"
                                               v-model="filter_selects.area">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null">-- Gebiet auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="2" v-if="active_filters.object_location === true">
                                <b-form-select class="black" plain
                                               :options="filters.object_location"
                                               v-model="filter_selects.object_location">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null">-- Objektstandort auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="2" v-if="active_filters.location === true">
                                <b-form-select class="black" plain
                                               :options="filters.location"
                                               v-model="filter_selects.location">
                                    <template v-slot:first>
                                        <b-form-select-option :value="null">-- Stand auswählen --
                                        </b-form-select-option>
                                    </template>
                                </b-form-select>
                            </b-col>
                            <b-col md="2" v-if="active_filters.search === true">
                                <b-form-input class="black" v-model="filter_selects.search" type="text" placeholder="Baumnummer">
                                </b-form-input>
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
            <b-row class="custom-flex-1">
                <b-col sm="12">
                    <b-card no-body style="border: none; height: 100%; margin: 0;">
                        <b-table striped bordered hover responsive id="my-table"
                                 class="custom-auto-height" no-local-sorting
                                 :current-page="currentPage" :per-page="0" :fields="fields" :items="items">
                            <template v-slot:cell(open)="data">
                                <open-icon  v-on:click="openControl(data.item.id)"
                                            class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                            style="color: green"></open-icon>
                            </template>
                        </b-table>
                        <div class="mt-3 custom-flex-0">
                            <b-pagination align="center"
                                          v-model="currentPage"
                                          :per-page="perPage"
                                          :total-rows="totalItems"></b-pagination>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
        </div>
    </template>

<script>
    import {Server_URL} from "../../shared/utils";
    import OpenIcon from 'vue-material-design-icons/OpenInNew.vue';

    export default {
        name: "all_controls",
        components: {
            OpenIcon
        },
        mounted() {
            this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/trees/filter'
            ).then(this.responseOkGetFilter, this.responseError)
        },
        data: () => {
            return {
                loader: undefined,
                currentPage: 1,
                perPage: 20,
                totalItems: 5000,
                wasMounted: false,
                items: [],
                fields: [
                ],
                search: "",
                filters: {
                },
                active_filters: {
                    commune: false,
                    tour: true,
                    city: true,
                    district: false,
                    area: false,
                    object_location: true,
                    location: false,
                    search: false,
                },
                filter_selects: {
                    commune: null,
                    tour: null,
                    city: null,
                    district: null,
                    area: null,
                    object_location: null,
                    location: null,
                    search: null,
                }
            }
        },
        watch: {
            currentPage: {
                handler: function(value) {
                    this.fetchData();
                }
            },
            filter_selects: {
                handler(val){
                    if (this.wasMounted) {
                        this.onSearch();
                    }
                },
                deep: true
            },
          active_filters: {
            handler(val){
              if (this.wasMounted) {
                this.setQuery();
              }
            },
            deep: true
          },
        },
        methods: {
            showLoader() {
                if (this.loader === undefined) {
                    this.loader = this.$loading.show();
                }
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGetFilter(response) {
                if (response.status === 200) {
                    console.log(response.data);
                    this.filters = response.data;
                    for (let i = 0; i < this.filters.table_options_controls.length; i++) {
                        let item = this.filters.table_options_controls[i];
                        this.fields.push({key: item.s_value_1, label: item.s_value});
                    }
                    this.fields.push({key: 'open', label: ""});
                  this.parseQuery();
                  this.$nextTick(() => {
                    this.fetchData();
                  });
                } else {
                    console.log(response);
                }
            },

            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.totalItems = response.data.count;
                    this.items = response.data.controls;
                } else {
                    console.log(response);
                }
            },
            onSearch() {
                let befor = this.currentPage;
                this.currentPage = 1;
                if (befor === this.currentPage) {
                    this.fetchData();
                }
            },
            getQuery() {
                let query = "?limit=" + this.perPage;
                query += "&page=" + (this.currentPage - 1);
                for (let param in this.active_filters) {
                    if (this.active_filters[param] === true && this.filter_selects[param] !== null) {
                        query += "&" + param + "=" + encodeURIComponent(this.filter_selects[param]);
                    }
                }
              this.setQuery();
                return query;
            },
            fetchData() {
                this.wasMounted = true;
                this.showLoader();
                this.$http.get(
                    Server_URL + '/baumkontrolle/controls' + this.getQuery()
                ).then(this.responseOkGet, this.responseError)
            },
            openControl(id) {
                this.$router.push("/control/control/" + id);
            },
          parseQuery() {
            let query = this.$route.query;
            if (query.limit !== undefined) {
              this.perPage = parseInt(query.limit);
            }
            if (query.page !== undefined) {
              this.currentPage = parseInt(query.page)+1;
            }
            if (query.page !== undefined) {
              for (let param in this.active_filters) {
                this.active_filters[param] = query[param+"_active"] === "true";
                if (query[param + "_filter"] !== undefined) {
                  this.filter_selects[param] = query[param + "_filter"];
                }
              }
            }
          },
          setQuery() {
            let query = {
              limit: this.perPage,
              page: this.currentPage-1,
            }
            let active_filters = [];
            for (let param in this.active_filters) {
              if (this.active_filters[param] === true) {
                query[param+"_active"] = "true";
              }
            }
            query.active_filters = active_filters;
            for (let param in this.filter_selects) {
              if (this.filter_selects[param] !== null) {
                query[param + "_filter"] = this.filter_selects[param];
              }
            }
            this.$router.push({query: query}).then(() => {}).catch(err => {});
          }
        }
    }
</script>
    <style>

        .black {
            color: #23282c;
        }
        .custom-100 {
            height: 100%;
            display: flex;
            flex-direction: column;
            -ms-flex-direction: column;
            -webkit-flex-direction: column;
        }

        .custom-flex-1 {
            flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            -webkit-flex: 1;
        }

        .custom-auto-height {
            flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            -webkit-flex: 1;
            max-height: 100%;
        }

        .custom-flex-0 {
            flex: 0;
            -moz-box-flex: 0;
            -ms-flex: 0;
            -webkit-flex: 0;
        }

        .sortingnone {
            background-position: right calc(0.75rem / 2) center;
            padding-right: calc(0.75rem + 0.65em);
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: 0.65em 1em;
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22zM51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
        }

        .sortingdesc {

            background-position: right calc(0.75rem / 2) center;
            padding-right: calc(0.75rem + 0.65em);
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: 0.65em 1em;
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
        }

        .sortingasc {

            background-position: right calc(0.75rem / 2) center;
            padding-right: calc(0.75rem + 0.65em);
            cursor: pointer;
            background-repeat: no-repeat;
            background-size: 0.65em 1em;
            background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' view-box='0 0 101 101' preserveAspectRatio='none'%3e%3cpath fill='black' opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3e%3cpath fill='black' d='M51 101l25-23 24-22H1l25 22z'/%3e%3c/svg%3e")
        }
    </style>

    <style scoped>

        .hoverable-icon:hover {
            cursor: pointer;
        }
    </style>
